




































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import './style.scss';
import _ from 'lodash-es';
import { formatNumber } from '@/utils/helpers';
import constants from '@/utils/constants';
@Component
export default class DishManagement extends Vue {
  @Prop(Function) hideDishManagement!: Function;
  @Prop(Function) reload!: Function;
  @Prop() dishManagementItem!: any;
  showConfirm: boolean = false;
  search_keyword: any = '';
  searchMenu: Object = [];
  menuData: any = [];
  submitLoading: boolean = false;
  $swal: any;
  constants: any = constants;
  formatPrice(val: any) {
    let date: any = val;
    return formatNumber(date);
  }
  get SearchMenu() {
    return this.$store.getters.GetSearchMenu;
  }
  get paging() {
    return this.$store.getters.PagingOrderReport;
  }
  showConfirmHandle() {
    this.showConfirm = true;
  }
  hideConfirmHandle() {
    this.showConfirm = false;
  }
  submitHandle() {
    const { orderId, notes } = this.dishManagementItem;
    const orderDetails = _.cloneDeep(this.dishManagementItem.orderDetails);
    orderDetails.map(item => {
      if (item.orderVariants && item.orderVariants.length) {
        item.variants = item.orderVariants.map(item => {
          const variant_detail_id = item.variant_details
            ? item.variant_details.map(item => (item.checked ? item.id : ''))
            : [];
          return {
            variant_id: Number(item.variant_id),
            variant_detail_id: variant_detail_id.filter(item => item !== '')
          };
        });
      }
    });
    const params = { orderId, notes, updateLines: orderDetails };
    if (!orderDetails.length) {
      this.hideConfirmHandle();
      return this.$swal(
        constants.SOMETHING_WROING,
        'Dishes list should not be empty!',
        constants.STATUS_ERROR
      );
    }
    this.submitLoading = true;
    this.$store
      .dispatch('SetOrder', params)
      .then(res => {
        if (
          res.code === constants.STATUS_200_STRING &&
          res.data.message === constants.STATUS_OK_UPPER
        ) {
          this.submitLoading = false;
          this.hideConfirmHandle();
          this.hideDishManagement();
          this.reload(this.paging.page);
          this.$swal(
            constants.COMPLETED_MESSAGE,
            res.message,
            constants.STATUS_SUCCESS
          );
        } else {
          this.submitLoading = false;
          this.$swal(
            constants.SOMETHING_WROING,
            res.message === constants.UPPER_SUCCESS
              ? res.invalidMessage
              : res.data.message,
            constants.STATUS_ERROR
          );
        }
      })
      .catch(e => {
        this.submitLoading = false;
      });
  }
  getMenudata() {
    const { outletCode, orderType } = this.dishManagementItem;
    this.$store.dispatch('SearchMenu', {
      data: {
        outlet_code: outletCode,
        order_type: orderType,
        search_keyword: this.search_keyword
      },
      menus: this.dishManagementItem.orderDetails
    });
  }
  @Watch('search_keyword')
  searchHandle() {
    this.getMenudata();
  }
  minusItem(item, index) {
    if (item.orderVariants && item.orderVariants.length) {
      if (!item.menuWithVariantsId) {
        item.menuWithVariantsId = new Date().getTime();
      }
      const { menuItemCode, quantity } = this.dishManagementItem.orderDetails[
        index
      ];
      this.dishManagementItem.orderDetails[index].quantity = quantity - 1;
      const searchMenuFromProps = _.cloneDeep(this.SearchMenu);
      for (let i = 0; i < searchMenuFromProps.length; i++) {
        const item = searchMenuFromProps[i];
        if (menuItemCode === item.menuItemCode) {
          item.quantity = quantity - 1;
        }
      }
      if (quantity <= 1) {
        this.dishManagementItem.orderDetails.splice(index, 1);
      }
      return;
    }
    const { menuItemCode, quantity } = this.dishManagementItem.orderDetails[
      index
    ];
    this.dishManagementItem.orderDetails[index].quantity = quantity - 1;
    const searchMenuFromProps = _.cloneDeep(this.SearchMenu);
    for (let i = 0; i < searchMenuFromProps.length; i++) {
      const item = searchMenuFromProps[i];
      if (menuItemCode === item.menuItemCode) {
        item.quantity = quantity - 1;
      }
    }
    if (quantity <= 1) {
      this.dishManagementItem.orderDetails.splice(index, 1);
    }
    this.$store.commit('SET_SEARCH_MENU', searchMenuFromProps);
  }
  plusItem(item, index) {
    if (item.orderVariants && item.orderVariants.length) {
      if (!item.menuWithVariantsId) {
        item.menuWithVariantsId = new Date().getTime();
      }
      const { quantity, menuItemCode } = this.dishManagementItem.orderDetails[
        index
      ];
      this.dishManagementItem.orderDetails[index].quantity = quantity + 1;
      const searchMenuFromProps = _.cloneDeep(this.SearchMenu);
      for (let i = 0; i < searchMenuFromProps.length; i++) {
        const item = searchMenuFromProps[i];
        if (menuItemCode === item.menuItemCode) {
          item.quantity = quantity + 1;
        }
      }
      return;
    }
    const { quantity, menuItemCode } = this.dishManagementItem.orderDetails[
      index
    ];
    this.dishManagementItem.orderDetails[index].quantity = quantity + 1;
    const searchMenuFromProps = _.cloneDeep(this.SearchMenu);
    for (let i = 0; i < searchMenuFromProps.length; i++) {
      const item = searchMenuFromProps[i];
      if (menuItemCode === item.menuItemCode) {
        item.quantity = quantity + 1;
      }
    }
    this.$store.commit('SET_SEARCH_MENU', searchMenuFromProps);
  }
  minusFromMenu(item, index) {
    const searchMenuFromData = _.cloneDeep(item);
    const cloneSearchMenu = _.cloneDeep(this.SearchMenu);
    const { menuItemCode, quantity } = searchMenuFromData;
    searchMenuFromData.quantity = quantity - 1;
    for (let i = 0; i < this.dishManagementItem.orderDetails.length; i++) {
      const item = this.dishManagementItem.orderDetails[i];
      if (item.menuItemCode === menuItemCode) {
        if (searchMenuFromData.quantity <= 0) {
          this.dishManagementItem.orderDetails.splice(i, 1);
        }
        item.quantity = searchMenuFromData.quantity;
      }
    }
    if (quantity <= 0) return;
    cloneSearchMenu[index] = searchMenuFromData;
    this.$store.commit('SET_SEARCH_MENU', cloneSearchMenu);
  }
  plusFromMenu(item, index) {
    const searchMenuFromData = _.cloneDeep(item);
    const cloneSearchMenu = _.cloneDeep(this.SearchMenu);
    const { quantity, menuItemCode } = searchMenuFromData;
    if (quantity <= 0 && !(item.orderVariants && item.orderVariants.length)) {
      this.dishManagementItem.orderDetails.push(searchMenuFromData);
    }
    searchMenuFromData.quantity = quantity + 1;
    for (let i = 0; i < this.dishManagementItem.orderDetails.length; i++) {
      const item = this.dishManagementItem.orderDetails[i];
      if (item.menuItemCode === menuItemCode) {
        item.quantity = searchMenuFromData.quantity;
      }
    }
    cloneSearchMenu[index] = searchMenuFromData;
    if (item.orderVariants && item.orderVariants.length) return;
    this.$store.commit('SET_SEARCH_MENU', cloneSearchMenu);
  }
  addFromMenuWithVariants(item, index) {
    const searchMenuFromData = _.cloneDeep(item);
    const cloneSearchMenu = _.cloneDeep(this.SearchMenu);
    for (let i = 0; i < searchMenuFromData.orderVariants.length; i++) {
      const element = searchMenuFromData.orderVariants[i];
      const min = Number(element.min);
      let checkboxCheckedArr: Array<any> = [];
      if (Number(element.option) === 1) {
        if (
          !JSON.stringify(element.variant_details).includes('"checked":true')
        ) {
          return this.$swal(
            constants.SOMETHING_WROING,
            `You have to pick one option`,
            constants.STATUS_ERROR
          );
        }
      }
      if (Number(element.option) === 2) {
        for (let j = 0; j < element.variant_details.length; j++) {
          const item = element.variant_details[j];
          if (item.checked) {
            checkboxCheckedArr.push(item);
          }
        }
        if (checkboxCheckedArr.length < min) {
          return this.$swal(
            constants.SOMETHING_WROING,
            `${element.category_name} minimum of ${min}`,
            constants.STATUS_ERROR
          );
        }
      }
    }
    searchMenuFromData.menuWithVariantsId = new Date().getTime();
    this.dishManagementItem.orderDetails.push(searchMenuFromData);
    searchMenuFromData.quantity = 1;
    searchMenuFromData.showVariants = false;
    const orderVariants = JSON.stringify(
      searchMenuFromData.orderVariants
    ).replace(/"checked":true/g, '"checked":false');
    cloneSearchMenu[index].orderVariants = JSON.parse(orderVariants);
    cloneSearchMenu[index].showVariants = false;
    this.$store.commit('SET_SEARCH_MENU', cloneSearchMenu);
  }
  showVariants(item) {
    if (item.showVariants) {
      item.showVariants = false;
    } else {
      item.showVariants = true;
    }
    this.$forceUpdate();
  }
  updateMenu(variant, index) {
    const { option, max, min, variant_details, category_name } = variant;
    if (Number(option) === 1) {
      for (let i = 0; i < variant_details.length; i++) {
        const item = variant_details[i];
        item.checked = false;
      }
      variant_details[index].checked = true;
    } else {
      variant_details[index].checked = !variant_details[index].checked;
      let checkedArr: Array<any> = [];
      for (let i = 0; i < variant_details.length; i++) {
        const element = variant_details[i];
        if (element.checked) {
          checkedArr.push(element);
        }
      }
      if (checkedArr.length > Number(max)) {
        variant_details[index].checked = false;
        return this.$swal(
          constants.SOMETHING_WROING,
          `${category_name} supports up to ${max}`,
          constants.STATUS_ERROR
        );
      }
      // if (checkedArr.length < Number(min)) {
      //   variant_details[index].checked = true;
      //   return this.$swal(
      //     constants.SOMETHING_WROING,
      //     `${category_name} minimum of ${min}`,
      //     constants.STATUS_ERROR
      //   );
      // }
    }
    this.$forceUpdate();
  }
  mounted() {}
}
